import { render, staticRenderFns } from "./AssessmentInvite.vue?vue&type=template&id=bdef8e54&"
import script from "./AssessmentInvite.vue?vue&type=script&lang=js&"
export * from "./AssessmentInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports